import { useState } from 'react'
import './Login.css'
import logo from './images/Magno_logo.png'
import { getApiUrl, getSessionId } from '../lib/intranet_tools_service'

export function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const onClickLogin = async (u: string, p: string) => {
    const result = await fetch(`${getApiUrl()}/login`, {
      method: 'post',
      headers: {
        'X-authenticated': getSessionId(),
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        username: u,
        password: p,
      }),
    })
    if (!result.ok) {
      const text = await result.text()
      setError(text)
    } else {
      const json = await result.json()
      if (json.token) {
        localStorage.setItem('MagnoToken', json.token)
        window.location.href = '/'
      } else {
        setError('Failed to login, please try again later')
      }
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login">
          <img id="Image2" className="logo" src={logo} />
          <div className="login-title">Log in</div>
          <div>
            <label htmlFor="username" className="login-label">
              Username
            </label>
            <input
              className="login-input"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="login-label">
              Password
            </label>
            <input
              className="login-input"
              id="password"
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <button
              className="login-btn"
              onClick={() => onClickLogin(username, password)}
            >
              Login
            </button>
          </div>
          <div className="login-error">{error}</div>
        </div>
      </div>
    </div>
  )
}
